import type { QueryClient } from '@tanstack/react-query';
import { fetchCountries, fetchStates } from '@/api/geography.api';
import { GEOGRAPHY_KEYS } from '@/hooks/geography.keys';
import { fetchSectors } from '../api/taxonomy.api';
import { TAXONOMY_KEYS } from './taxonomy.keys';

const STALE_TIME_MS = 24 * 60 * 60 * 1000;

/**
 * Warms the Country/State/Sector caches as early as possible - before an
 * individual reaches the create-startup wizard, not when Step 1 mounts - so
 * the HQ and Sector dropdowns show zero visible loading state by the time
 * they're needed (MYN-46 "cache values so the user doesn't see any delay").
 */
export function prefetchGeographyAndTaxonomy(queryClient: QueryClient) {
  void queryClient.prefetchQuery({
    queryKey: GEOGRAPHY_KEYS.countries,
    queryFn: fetchCountries,
    staleTime: STALE_TIME_MS,
  });
  void queryClient.prefetchQuery({
    queryKey: GEOGRAPHY_KEYS.states,
    queryFn: fetchStates,
    staleTime: STALE_TIME_MS,
  });
  void queryClient.prefetchQuery({
    queryKey: TAXONOMY_KEYS.sectors,
    queryFn: fetchSectors,
    staleTime: STALE_TIME_MS,
  });
}
